import { useState } from "react";
import { debugLogStore } from "../../core/debug-log.js";
import { reportContext, SendDebugReportDialog } from "./DebugLogPanel.js";
import { errorReportDraft } from "./error-report.js";

/** Mount with the failure, keyed by error/job identity, to preserve its diagnostics. */
export function ReportErrorButton({ source, message, detail }: {
  source: string; message: string; detail?: string;
}) {
  const [open, setOpen] = useState(false);
  const [snapshot] = useState(() => ({
    ...errorReportDraft(source, message, debugLogStore.getState().entries, detail),
    context: reportContext(),
  }));
  return <>
    <button type="button" className="btn btn-ghost" onClick={() => setOpen(true)}>
      Report to developer
    </button>
    {open && <SendDebugReportDialog
      entries={snapshot.entries}
      initialNote={snapshot.note}
      context={snapshot.context}
      onClose={() => setOpen(false)}
    />}
  </>;
}
